<template>
    <div :class="['download-as-excel',(ete.isLoadingData)? 'loading':'ready']">
        <span v-if="ete.isLoadingData">Preparing Excel file...</span>
        <span v-else="ete.isLoadingData" @click="exportToExcelClick">Download as Excel</span>
    </div>
</template>

<script>
    import exportToExcel from '@/helpers/exportToExcel.js'
    export default {
        name: "Excel_Export_Link",
        props: {
            type: {
                type: String,
                required:true
            }
        },
        data:() => ({
            ete: exportToExcel,
        }),

        methods: {
            exportToExcelClick() {
                this.ete.export(this.type, this)
            },
        }
    }
</script>